// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();


$(window).on('load', function(){
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	if(urlParams.get("enquiry")){
		$("#wpforms-366-field_3 option[value='" + urlParams.get("enquiry") + "']").attr("selected", "selected")
		$([document.documentElement, document.body]).animate({
			scrollTop: $("#enquiryFormContainer").offset().top - 120
		}, 2000);
	}
})